import { Component, OnInit, OnDestroy } from '@angular/core';
import { SeedTreatmentSearchRequest, TankmixTest } from '../../../models/searchRequest';
import { ApiService } from '../../../services/api.service';

import { PreferencesService } from '../../../services/preferences.service';
import { ReferenceDataService } from '../../../services/reference-data.service';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NamedId } from '../../../models/NamedId';
import { Subscription} from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SearchHistoryService } from '../../../services/search-history.service';
import { SearchRequestHistoryItem } from '../../../models/searchRequestHistoryItem';
import { ActivatedRoute } from '@angular/router';
import { KindPage } from '../../../enums/kind-page';

@Component({
  selector: 'app-helena-search-seed-treatment',
  templateUrl: './helena-search-seed-treatment.component.html'
})
export class HelenaSearchSeedTreatmentComponent implements OnInit {

  faFilePdf: any = faFilePdf;
  showIntroduction: boolean = true;
  countryChoices: NamedId[] = [];
  yaraProductChoices: NamedId[] = [];
  activeIngredientChoices: NamedId[] = [];
  agrochemicalChoices: NamedId[] = [];
  cropChoices: NamedId[] = [
    { id: '1', name: 'Wheat' },
    { id: '2', name: 'Barley' },
    { id: '3', name: 'Oats' },
  ];
  results: TankmixTest[] = null;
  
  searching: boolean;
  preferencesSub: Subscription;
  searchForm: UntypedFormGroup;
  countryChosen: boolean;
  searchHistoryItem: SearchRequestHistoryItem;

  constructor(private api: ApiService,
    private route: ActivatedRoute,
    private refData: ReferenceDataService,
    private searchHistory: SearchHistoryService,
    private fb: UntypedFormBuilder, private preferencesService: PreferencesService
  ) {
    this.showIntroduction = true;
    this.searchForm = this.fb.group({
      countryCode: [null],
      seedName: [null],
      benefitName: [null],
      yaraChemicalId: [null],
      extraRestriction:['Helena']
    });
  }
  ngOnDestroy(): void {
    
  }

  ngOnInit() {
    this.preferencesService.forceToAmerica()
     this.getHelenaYaraProducts();

     // Check if page is visited from search history
      let index = this.route.snapshot.params.id;
      if (index != undefined) {
       this.searchHistoryItem = this.searchHistory.getHistoryItem(index);
       if (this.searchHistoryItem  == undefined) {return;}
       this.pathFormWithSearchCriteria();
      }

  }

  pathFormWithSearchCriteria() {
    var criteria = this.searchHistoryItem.criteria;
    this.searchForm.patchValue(criteria);
    this.performSearch();
  }
  searchAgain() {
    this.results = null;
  }
  resetSearch() {
    this.searchForm.patchValue({ sedName: null, benefitName: null, yaraChemicalId: null });
  }

  toggleIntroduction() {
    this.showIntroduction = !this.showIntroduction;
  }

  getHelenaYaraProducts() {
    this.refData.setCountry('US').subscribe(x => { 
      this.yaraProductChoices = x;
     
    });
  }

  performSearch() {
    this.searching = true;
    this.api.searchSeedTreatments(this.searchForm.value).subscribe((x: TankmixTest[]) => {
      this.results = x;
      this.searching = false;

         // store result in local storage
         this.storeSearchCriteria(this.searchForm.value, x.length);
    });
  }

  private storeSearchCriteria(criteria: any, numberOfResults: number) {
    console.log(criteria);
    this.searchHistory.storeSearchCritera(criteria,numberOfResults, KindPage.SeedCoating);
  }
}

